import React, { useState } from 'react';
import { useQuery, useMutation } from '@apollo/client';
import getAllTodos from '../apollo/Query/getAllTodos';
import addTodo from '../apollo/Mutation/addTodo';
import deleteTodo from '../apollo/Mutation/deleteTodo';

export default function Todos() {
  const [todo, setTodo] = useState({
    title: '',
    item: '',
  });

  const [AddTodo] = useMutation(addTodo, {
    onError: (error) => {
      alert(error.message);
    },
    onCompleted: ({ addTodo }) => {
      if (addTodo.status === 201) {
        alert(addTodo.message);
        // clearing
        setTodo({ title: '', item: '' });
      }
    },
    refetchQueries: ['getAllTodos'],
  });

  const onHandleChange = (e) => {
    setTodo({
      ...todo,
      [e.target.name]: e.target.value,
    });
  };

  const { loading, data } = useQuery(getAllTodos, {
    onError: (error) => {
      alert(error.message);
    },
  });

  const [DeleteTodo] = useMutation(deleteTodo, {
    onError: (error) => {
      alert(error.message);
    },
    onCompleted: ({ deleteTodo }) => {
      if (deleteTodo.status === 201) {
        alert(deleteTodo.message);
      }
    },
    refetchQueries: ['getAllTodos'],
  });

  const upperCase = () => {
    setTodo({ title: todo.title.toUpperCase(), item: todo.item.toUpperCase() });
  };
  const lowerCase = () => {
    setTodo({ title: todo.title.toLowerCase(), item: todo.item.toLowerCase() });
  };
  const handleCopy = () => {
    navigator.clipboard.writeText(todo.item);
  };
  const reset = () => {
    setTodo({ title: '', item: '' });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    AddTodo({
      variables: {
        newtodo: {
          title: todo.title,
          item: todo.item,
        },
      },
    });
  };

  if (loading) return <h1 className='text-center mt-5'>Loading...</h1>;
  const Data = data?.getAllTodos?.payload;
  // **********************************************
  return (
    <>
      <div className='container my-3 Todos'>
        <form>
          <div className='mb-3'>
            <input
              type='text'
              name='title'
              onChange={onHandleChange}
              value={todo.title}
              className='form-control'
              style={{ backgroundColor: 'lightgrey' }}
              id='title'
              placeholder='Title'
              aria-describedby='title'
              required
            />
          </div>
          <div className='mb-3'>
            <textarea
              type='text'
              name='item'
              value={todo.item}
              onChange={onHandleChange}
              className='form-control'
              style={{ backgroundColor: 'lightgrey' }}
              id='text'
              placeholder='Enter your todos item...'
              required
            />
          </div>{' '}
          <hr />
        </form>
        <div className='text-center'>
          <button disabled={todo.title.length === 0} className=' btn btn-danger mx-2 ' onClick={upperCase}>
            UpperCase
          </button>
          <button disabled={todo.title.length === 0} className=' btn btn-warning mx-2 my-2' onClick={lowerCase}>
            LowerCase
          </button>
          <button disabled={todo.title.length === 0} className=' btn btn-info mx-2 my-2' onClick={handleCopy}>
            Copy Text
          </button>
          <button disabled={todo.title.length === 0} className=' btn btn-dark mx-2 my-2' onClick={reset}>
            Reset
          </button>
          <button
            type='submit'
            disabled={todo.title.length === 0}
            onClick={handleSubmit}
            className='btn btn-primary mx-2 my-2'
          >
            Submit &rarr;
          </button>
        </div>
      </div>

      <div id='opop' className='container my-5'>
        <h1 className='text-center'>
          <b> Your Todos-List </b>
        </h1>{' '}
        <hr />
        {Data.length === 0 ? (
          <p className='text-center'>No Todos to display</p>
        ) : (
          Data?.map((event, i) => {
            return (
              <div key={i}>
                <div id='hehe' className='container' style={{ background: 'lightpink' }}>
                  <h3 style={{ color: '#f1356d' }}>{event.title}</h3>
                  <p style={{ color: 'black' }}>{event.item}</p>

                  <button
                    onClick={() =>
                      DeleteTodo({
                        variables: {
                          id: event._id,
                        },
                      })
                    }
                    className='btn btn-sm btn-dark my-1'
                  >
                    <i className='bi bi-trash'></i>Delete
                  </button>
                </div>{' '}
                <hr />
              </div>
            );
          })
        )}
      </div>
    </>
  );
}
